import Cookies from 'js-cookie'
import { sumPrice, web_price } from "../plugins/api/common"; 
import { amountinfo } from "../plugins/api/amount";
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = () => new Vuex.Store({
    state: {
        isLogin: false,
        loginUser: {},
        inviCode: "",
        currentPage: '/',
        loading: false,
        signalLoading: false,
        //移动模式，去除header和footer
        mobileMode: false,
        priceList: [],
        usdVal: 0,
        btcVal: 0,
        balanceList: []
    },
    getters: {
        curLoginUser: state => {
            // console.log("getter cookie - " + Cookies.get("OTC919-token"));
            let curLogUser = localStorage.getItem("userInfo");
            if (curLogUser) {
                curLogUser = JSON.parse(curLogUser)
                state.loginUser = curLogUser
            }
            if (Cookies.get("OTC919-token")) {
                // state.loginUser.token = Cookies.get("OTC919-token")
                return state.loginUser
            }
            else {
                return undefined;
            }
        },
        inviCode: state => {
            state.inviCode = Cookies.get("OTC919-inviCode");
            return state.inviCode
        },
        commonPrice: state => {
            return state.priceList
        },
        balanceList: state => {
            return state.balanceList
        }
    },
    mutations: {
        setCommonPrice(state, temp) {
            // web_price().then((pricedata) => {
            //     state.priceList = pricedata.data
            //     amountinfo().then((data) => {
            //         state.balanceList = data
            //         state.usdVal = sumPrice(data, pricedata.data, "USD", 2);
            //         state.btcVal = sumPrice(data, pricedata.data, "BTC", 4);
            //     });
            // });
        },
        setLoading(state, show) {
            state.loading = show;
        },
        setSignalLoading(state, show) {
            state.signalLoading = show;
        },
        increment(state) {
            state.counter++
        },
        setInviCode(state, code) {
            Cookies.set("OTC919-inviCode", code);
            state.inviCode = code;
        },
        setLogin(state, userInfo) {
            // console.log(` setLogin(state, userInfo) `)
            // console.log(userInfo)
            if (userInfo) {
                localStorage.setItem("userInfo", JSON.stringify(userInfo.userInfo));
                // localStorage.getItem("userInfo")
                Cookies.set("OTC919-userName", userInfo.userInfo.realName);
                Cookies.set("OTC919-token", userInfo.token);
                state.loginUser = userInfo.userInfo;
                // localStorage.setItem("userInfo", JSON.stringify(userInfo.userInfo))
                state.isLogin = true;
            } else {
                Cookies.remove("OTC919-userName");
                Cookies.remove("OTC919-token");
                localStorage.removeItem('userInfo')
                state.loginUser = undefined;
                state.isLogin = false;
            }
        },
        setCurrentPage(state, curPage) {
            state.currentPage = curPage;
        },
        setMobileMode(state, mobileMode) {
            state.mobileMode = mobileMode;
        }
    }
})


// export const 

// export default state

export default store